import * as React from "react";
import { FormatMessage as FormatMessageComponent } from "react-globalize";
import Reminders from "components/product-media/components/reminders";
import { ASSORTMENTS } from "constants/integration/assortments";

interface IProps {
    items: string[];
    wasUpdated: boolean;
}

export const SummarizeDoorsTurnedOnOrOff: React.FC<IProps> = ({ items, wasUpdated }) => {
    const title = wasUpdated ? (
        <FormatMessageComponent
            path="[strong]|count| doors[strong] have been turned |OnOrOff|:"
            elements={{ strong: <b /> }}
            variables={{
                count: items.length,
                OnOrOff: "on/off",
            }}
        />
    ) : (
        <FormatMessageComponent
            path="[strong]Doors[strong] to be turned |OnOrOff|:"
            elements={{ strong: <b /> }}
            variables={{
                OnOrOff: "on/off",
            }}
        />
    );
    return (
        <Reminders
            title={title}
            shouldUseCurrentColor
            dataTestList={ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.DOORS.LIST}
            dataTestTitle={ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.DOORS.TITLE}
        >
            {items.map((col, index) => (
                <li
                    key={`${col}-${index}`}
                    data-test={`${ASSORTMENTS.ALLOCATION_DIMENSIONS.IMPORT_DOOR_GROUPINGS.SUMMARIZE_COLUMN.DOORS.ITEM}-${index}`}
                >
                    {col}
                </li>
            ))}
        </Reminders>
    );
};
